<template>
  <div>
    <div class="kqf-card mg10 search-box mt20">
      <el-form
        :inline="true"
        :model="search"
        size="mini"
        class="demo-form-inline"
      >
        <el-col :span="24">
          <el-form-item label="入账类型：">
            <el-radio-group v-model="search.entry_type" @input="getList(1)">
              <el-radio :label="-1">全部</el-radio>
              <el-radio :label="1">加</el-radio>
              <el-radio :label="2">减</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="分类：" class="ml20">
            <el-select v-model="search.type" @input="getList(1)">
              <el-option label="全部" :value="-1"></el-option>
              <el-option label="充值" :value="1"></el-option>
              <el-option label="消费" :value="2"></el-option>
              <el-option label="后台充值" :value="3"></el-option>
              <el-option label="后台扣除" :value="4"></el-option>
              <el-option label="赠送" :value="5"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="创建时间：" class="ml20">
            <div class="block">
              <el-date-picker
                v-model="search.created_at"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <div class="line-dashed mb10"></div>
        </el-col>
        <el-form-item label="关键字：">
          <el-input v-model="search.keyword" placeholder="名称"></el-input>
        </el-form-item>
        <el-form-item label="备注：" class="ml20">
          <el-input v-model="search.remarks" placeholder="备注"></el-input>
        </el-form-item>
        <el-form-item label="入账ID：" class="ml20">
          <el-input v-model="search.entry_id" placeholder="入账ID"></el-input>
        </el-form-item>
        <el-form-item class="ml20">
          <el-button type="primary" @click="getList(1)">查询</el-button>
          <el-button @click="refresh">重置</el-button>
        </el-form-item>
        <el-form-item>
          <div class="allMoney">
            总金额：<span class="num">{{ datas.allMoney }}</span>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div
      class="kqf-card mg10 pd10 mt20"
      v-loading="loading"
      style="min-width: 1100px"
    >
      <el-table border :data="datas.list" height="calc(100vh - 330px)">
        <el-table-column label="ID" width="80" prop="log_id"></el-table-column>
        <el-table-column label="用户信息" width="250">
          <template slot-scope="scope">
            <div class="flex">
              <el-avatar :size="40" :src="scope.row.face"></el-avatar>
              <div style="margin-left: 10px">
                <p class="text-over">{{ scope.row.nickname }}</p>
                <el-link
                  v-clipboard:success="copySuccess"
                  v-clipboard:copy="scope.row.mobile"
                  type="primary"
                  :underline="false"
                  >{{ scope.row.mobile }}
                </el-link>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作金额" width="150">
          <template slot-scope="scope">
            <p v-if="scope.row.entry_type == 1">+{{ scope.row.money }}</p>
            <p v-if="scope.row.entry_type == 2">-{{ scope.row.money }}</p>
          </template>
        </el-table-column>
        <el-table-column
          label="操作后金额"
          width="150"
          prop="now_money"
        ></el-table-column>
        <el-table-column label="入账类型" width="100" align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.entry_type == 1">加</el-tag>
            <el-tag type="danger" v-if="scope.row.entry_type == 2">减</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="类型" width="100" align="center">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.type == 1">充值</el-tag>
            <el-tag type="danger" v-if="scope.row.type == 2">消费</el-tag>
            <el-tag type="info" v-if="scope.row.type == 3">后台充值</el-tag>
            <el-tag type="warning" v-if="scope.row.type == 4">后台扣除</el-tag>
            <el-tag v-if="scope.row.type == 5">赠送</el-tag>
            <el-tag v-if="scope.row.type == 6">兑换</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="入账ID"
          width="100"
          prop="entry_id"
          align="center"
        ></el-table-column>
        <el-table-column label="备注" prop="remarks"></el-table-column>
        <el-table-column
          label="创建时间"
          width="200"
          prop="created_at"
        ></el-table-column>
        <el-table-column
          label="更新时间"
          width="200"
          prop="updated_at"
        ></el-table-column>
      </el-table>
      <div class="flex center mt10">
        <div>
          <el-pagination
            @current-change="getList"
            background
            :page-size="datas.limit"
            layout="total, prev, pager, next"
            :total="datas.count"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getAmountList } from "../../request/api/amountList/amountList";

export default {
  data() {
    return {
      datas: [],
      search: this.getSearch(),
      //编辑信息
      editloading: false,
      editdialog: false,
      editdata: {
        keyword: "",
        remarks: "",
        entry_type: -1,
        type: -1,
        entry_id: "",
        created_at: ""
      },
      loading: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      }
    };
  },
  created() {
    this.getList();
  },
  methods: {
    getSearch() {
      return {
        keyword: "",
        remarks: "",
        entry_type: -1,
        type: -1,
        entry_id: "",
        created_at: "",
        page: 1
      };
    },
    getList(page) {
      this.search.page = page;
      this.loading = true;
      getAmountList({
        keyword: this.search.keyword,
        remarks: this.search.remarks,
        entry_type: this.search.entry_type,
        type: this.search.type,
        entry_id: this.search.entry_id,
        created_at: this.search.created_at,
        page: page
      })
        .then(res => {
          this.datas = res;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    refresh() {
      this.search = this.getSearch();
      this.getList(1);
    },
    // 复制
    copySuccess() {
      this.$message.success("复制成功");
    }
  }
};
</script>

<style scoped>
.allMoney {
  margin-left: 20px;
}
.allMoney .num {
  font-size: 15px;
  color: #ff5646;
}
</style>
